/*
 * Copyright © 2020-2022 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2022-07-25 11:35:41
 */
import React, { useCallback } from 'react'
import { Checkbox, Form, Input } from 'antd'
import { useAppSelector, useAppDispatch } from '../../../../app/hooks'
import { setEditorWatermark } from '../../../../actions/watermark'
import { subWatermarkText } from '../../../../utils/utils'

const FormItem = Form.Item
const { TextArea } = Input

interface TextContentProps {
  index: number
  contentMaxLength: number
}

const TextContent: React.FC<TextContentProps> = (props) => {
  const { index, contentMaxLength } = props
  const watermark = useAppSelector((state) => state.editor.watermark)
  const dispatch = useAppDispatch()
  const onChange = (newWatermark) => dispatch(setEditorWatermark(newWatermark))

  const onContentChange = useCallback(
    (e) => {
      let newItems = watermark.items.map((it, idx) => {
        if (idx !== index) return it
        let newItem = {
          ...it,
          content: subWatermarkText(e.target.value.trim(), contentMaxLength)
        }
        if (!e.target.value.trim()) {
          newItem = {
            ...newItem,
            contentEdit: {
              ...newItem.contentEdit,
              editType: 0
            }
          }
        }
        return newItem
      })
      onChange({ ...watermark, items: newItems })
    },
    [watermark]
  )

  const onEmployeeEditableChange = useCallback(
    (e) => {
      const newItems = watermark.items.map((it, idx) => {
        if (idx !== index) return it
        if (e.target.checked) {
          return {
            ...it,
            editType: 0,
            contentEdit: {
              ...it.contentEdit,
              editType: 1,
              placeholder: ''
            }
          }
        } else {
          return {
            ...it,
            editType: 2,
            contentEdit: {
              ...it.contentEdit,
              editType: 0
            }
          }
        }
      })
      onChange({ ...watermark, items: newItems })
    },
    [watermark]
  )

  return (
    <div>
      <FormItem label="内容">
        <TextArea
          autoSize={{ minRows: 2, maxRows: 6 }}
          placeholder="请输入固定显示内容..."
          value={watermark.items[index]?.content}
          onChange={onContentChange}
        />
        <Checkbox
          disabled={!watermark.items[index]?.content}
          checked={
            watermark.items[index]?.contentEdit?.editType === 1
          }
          onChange={onEmployeeEditableChange}
        >
          员工不可修改内容
        </Checkbox>
        {watermark.items[index]?.contentEdit?.editType === 0 && (
          <FormItem label="提示文字">
            <Input
              placeholder="选填，可为员工输入范围或注意事项"
              value={watermark.items[index]?.contentEdit?.placeholder}
              onChange={(e) => {
                const newItems = watermark.items.map((it, idx) =>
                  idx === index
                    ? {
                        ...it,
                        contentEdit: {
                          ...it.contentEdit,
                          placeholder: subWatermarkText(e.target.value.trim(), contentMaxLength)
                        }
                      }
                    : it
                )
                onChange({ ...watermark, items: newItems })
              }}
            />
          </FormItem>
        )}
      </FormItem>
    </div>
  )
}

export default TextContent
